export default __webpack_public_path__ + "assets/images/2e7cfad4b47b7b13e7ebf64fcae1ed1c.jpg";